import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody } from "reactstrap";
import { Link, useLocation, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const OrganizationManagement = props => {
	document.title = "Organization Management";
	const location = useLocation();
    const history = useHistory();
	React.useEffect(() => {
		if (localStorage.getItem('admin_type') !== 'admin') {
			history.replace('/dashboard');
		}
	}, [history]);
	const { getRequest, postRequest } = useRequests();

	const [AlertData, setAlertData] = useState({ variant: '', message: '' });
	const [modal_Delete_Organization, setmodal_Delete_Organization] = useState(false);
	const [deleteOrganizationId, setDeleteOrganizationId] = useState(null);
	const [OrganizationData, setOrganizationData] = useState([]);
	const [OrganizationTBody, setOrganizationTBody] = useState('');
	// Status modal state
	const [statusModal, setStatusModal] = useState(false);
	const [selectedOrgId, setSelectedOrgId] = useState(null);
	const [status, setStatus] = useState("");

	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData({ variant: '', message: '' });
		}, 5000);
	};

	function Delete_Organization(a_id) {
		setDeleteOrganizationId(a_id);
		setmodal_Delete_Organization(!modal_Delete_Organization);
	}

	// Open modal for changing status
	const openStatusModal = (a_id, currentStatus) => {
		setSelectedOrgId(a_id);
		setStatus(currentStatus === "active" ? "inactive" : "active");
		setStatusModal(true);
	};

	const handleChangeStatus = async () => {
		try {
			const jsonpar = JSON.stringify({ a_id: selectedOrgId, status: status });
			const res = await postRequest('update-organization-status', jsonpar);
			if (res && res.code === 200) {
				setAlertData({ variant: 'success', message: res.message || 'Status updated successfully' });
				handleLoadGetOrganization();
			} else {
				setAlertData({ variant: 'error', message: res.message || 'Failed to update status' });
			}
		} catch (error) {
			setAlertData({ variant: 'error', message: 'Something went wrong while updating status' });
		}
		resetAlertData();
		setStatusModal(false);
	};

	const handleDeleteOrganization = async () => {
		try {
			const jsonpar = JSON.stringify({ a_id: deleteOrganizationId });
			const res = await postRequest('delete-organization', jsonpar);
			if (res && res.code === 200) {
				setAlertData({ variant: 'success', message: res.message });
				setDeleteOrganizationId(null);
				handleLoadGetOrganization();
			} else {
				setAlertData({ variant: 'error', message: res.message || 'Failed to delete organization' });
			}
		} catch (error) {
			setAlertData({ variant: 'error', message: 'Something went wrong while deleting organization' });
		}
		resetAlertData();
		setmodal_Delete_Organization(false);
	};

	const handleT1Body = async (tempData) => {
		let tempTBody = tempData.map((element, index) => (
			<tr key={index}>
				<td>{element.organization_name}</td>
				<td>{element.location}</td>
				<td>{element.supervisor}</td>
				<td>{element.userid || '-'}</td>
				<td>{element.email}</td>
				<td>{element.mobile}</td>
				<td>
					<Button
						className="status-btn"
						color={element.status === "active" ? "success" : "danger"}
						onClick={() => openStatusModal(element.a_id, element.status)}
					>
						{element.status ? element.status.toUpperCase() : ''}
					</Button>
				</td>
				<td className="text-center">
					<div className="centerLink">
						<Link
							title="Edit Organization"
							to={"/edit_organization/" + btoa(element.a_id)}
							className="font-size-14 bg-primary edit-box"
						>
							<i className="bx bxs-edit"></i>
						</Link>
						<Link
							title="Delete Organization"
							to="#"
							className="font-size-14 bg-primary edit-box"
							onClick={() => { Delete_Organization(element.a_id) }}
						>
							<i className="bx bx-trash"></i>
						</Link>
					</div>
				</td>
			</tr>
		));
		setOrganizationTBody(tempTBody);
	};

	const handleLoadGetOrganization = async () => {
		const res = await getRequest('get-organization');
		if (res && res.code === 200) {
			setOrganizationData(res.data);
			handleT1Body(res.data);
		} else {
			let tempTBody = (<tr><td colSpan="7" className="text-center">No records found</td></tr>);
			setOrganizationTBody(tempTBody);
			setAlertData({ variant: 'error', message: res.message });
		}
		resetAlertData();
	};

	React.useEffect(() => {
		handleLoadGetOrganization();
		if (location.state && location.state.message) {
			setAlertData({ variant: location.state.status, message: location.state.message });
			resetAlertData();
		}
		// eslint-disable-next-line
	}, []);

	return (
		<React.Fragment>
			{AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
			<div className="page-content">
				<Container fluid>
					<Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Organization Management")} />
					<Row>
						<Col lg="12">
							<Card>
								<CardBody>
									<div className="table-rep-plugin">
										<div className="table-responsive mb-0">
											<table className="table table-hover table-highlight" style={{ minWidth: '1000px' }}>
												<thead>
													<tr>
														<th>Organization Name</th>
														<th>Location</th>
														<th>Supervisor Name</th>
														<th>Username</th>
														<th>Email</th>
														<th>Mobile Number</th>
														<th>Status</th>
														<th className="text-center">Actions</th>
													</tr>
												</thead>
												<tbody>
													{OrganizationTBody}
												</tbody>
											</table>
										</div>
										<div className="infoIcon">
											<div className="infoIconBox">
												<i className="bx bxs-edit"></i>
												<p>Edit Organization</p>
											</div>
											<div className="infoIconBox">
												<i className="bx bx-trash"></i>
												<p>Delete Organization</p>
											</div>
										</div>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
			{/* Delete Modal */}
			<Modal isOpen={modal_Delete_Organization} toggle={() => { Delete_Organization(); }} backdrop={'static'} centered className="transation">
				<div>
					<div className="modal-header">
						<h5 className="modal-title mt-0">Delete Organization</h5>
						<button type="button" onClick={() => { setmodal_Delete_Organization(false); }} className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<ModalBody>
						<p>Are you sure you want to delete this organization?</p>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="primary" onClick={handleDeleteOrganization} >Delete</Button>
						<Button type="button" color="light" onClick={() => { setmodal_Delete_Organization(false); }} >Cancel</Button>
					</ModalFooter>
				</div>
			</Modal>
			{/* Status Change Modal */}
			<Modal isOpen={statusModal} toggle={() => setStatusModal(!statusModal)} centered>
				<ModalBody>
					<h5>Change Status</h5>
					<p>Are you sure you want to update the status?</p>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={() => setStatusModal(false)}>Cancel</Button>
					<Button color="primary" onClick={handleChangeStatus}>Change Status</Button>
				</ModalFooter>
			</Modal>
		</React.Fragment>
	);
};

export default withTranslation()(OrganizationManagement);
